import { RedcatApiHandler } from 'polygon-utils';
import { API_HANDLER_NOT_READY_MESSAGE } from '../constants';

export interface ApiResponse {
  [key: string]: any;
  data: any;
  success: any;
  error?: any;
}

type HTTPMethods = 'GET' | 'PUT' | 'POST' | 'DELETE' | 'PATCH';

export interface FetchParams {
  method: HTTPMethods;
  path: string;
  body?: object;
  headers?: Record<string, string | number>;
  applicationErrorAllowed?: boolean;
}

export type AuthenticationMethod = 'trusted' | 'member' | 'none';

export default class Api {
  static handler?: typeof RedcatApiHandler;

  static setHandler(handler: typeof RedcatApiHandler) {
    Api.handler = handler;
  }

  static fetch<T = ApiResponse>(
    params: FetchParams,
    authenticationMethod: AuthenticationMethod = 'none',
  ): Promise<T> {
    if (Api.handler) {
      switch (authenticationMethod) {
        case 'trusted':
          return Api.handler.trustedFetch(params) as Promise<T>;
        case 'member':
          return Api.handler.authorisedFetch(params) as Promise<T>;
        case 'none':
          return Api.handler.fetch(params) as Promise<T>;
      }
    }

    return Promise.reject(API_HANDLER_NOT_READY_MESSAGE);
  }
}
